export function getOpenAccountButton() {
    return $<HTMLButtonElement>('#account_button');
}
